import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinIssueAssignRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue-assign',
	path: '/secure/(\\w*)AssignIssue([!%]?[\\w]*).jspa',
};
